export enum CustomClaim {
 userId = 'UserId',
 contrAgentId = 'ContragentId',
 isAdmin = 'IsAdmin',
 isEngineer = 'IsEngineer',
 isClient = 'IsClient',
 isSCUser = 'IsSCUser',
 isOperator = 'IsOperator'
}
